<template>
  <div class="index">
    <van-nav-bar title="填写调研问卷" fixed left-arrow @click-left="$router.back()" style="z-index: 9999999" />
    <div class="index-bgc">
      <div class="index-head">淋巴瘤CAR-T治疗全程管理项目</div>
      <!-- 表单 -->
      <div class="index-form">
        <el-form :model="form" :rules="rules" ref="form" class="form" label-position="top">
          <!-- ------------------------------------------------------------------------------------------ -->
          <!-- 1 -->
          <div class="form-in">
            <el-form-item style="margin-top: 0;" class="form-radio-b form-radio-t"
              label="1、您接诊的接受了CAR-T治疗的淋巴瘤病例，一线治疗的具体方案为：" prop="one_checkbox" ref="one_checkbox">
              <el-checkbox-group v-model="form.one_checkbox">
                <el-checkbox label="1" name="type">R-CHOP</el-checkbox>
                <el-checkbox label="2" name="type">R-CHOP+放疗</el-checkbox>
                <el-checkbox label="3" name="type">Pola-R-CHP</el-checkbox>
                <el-checkbox label="4" name="type">R-CHOEP</el-checkbox>
                <el-checkbox label="5" name="type">R-DA-EPOCH</el-checkbox>
                <el-checkbox label="6" name="type">自体造血干细胞移植</el-checkbox>
                <el-checkbox label="7" name="type">R-CEOP90</el-checkbox>
                <el-checkbox label="8" name="type" class="form-checkbox-br"
                  style="margin-bottom: 15px;">R-CHOP+X（来那度胺、BCL-2抑制剂、PD-1单抗、地西他滨、西达本胺）</el-checkbox>
                <el-checkbox label="9" name="type">R-GemOx</el-checkbox>
                <el-checkbox style="margin-bottom: 15px;" label="10" name="type" class="form-checkbox-br">
                  Chemo-free方案（CD20单抗+BTK抑制剂+来那度胺）
                </el-checkbox>
                <el-checkbox style="margin-bottom: 0;" label="11" name="type">临床试验</el-checkbox>
                <el-checkbox style="margin-bottom: 0;" label="12" name="type">其他</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item style="margin-top: 0;" class="form-radio-b" prop="one_checkbox_input" ref="one_checkbox_input"
              v-if="form.one_checkbox.includes('12') == true">
              <el-input v-model="form.one_checkbox_input" placeholder="请输入内容" />
            </el-form-item>
          </div>
          <!-- 2 -->
          <div class="form-in">
            <el-form-item class="el-form-item-radio-b" label="2、本病例从上次治疗结束到本次复发的时间间隔为：" prop="two_radio" ref="two_radio">
              <el-radio-group v-model="form.two_radio">
                <el-radio :label="1">3个月内</el-radio>
                <el-radio :label="2" class="el-form-item-radio-b">3-6个月</el-radio>
                <el-radio :label="3">6-9个月</el-radio>
                <el-radio :label="4">9-12个月</el-radio>
                <el-radio :label="5">一年以上</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <!-- 3 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="3、本次就诊的主要治疗方案：" prop="three_radio" ref="three_radio">
              <el-radio-group v-model="form.three_radio">
                <el-radio :label="1">CAR-T细胞治疗</el-radio>
                <el-radio :label="2">其他</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="form-radio-b" style="margin-top: 0;" prop="three_radio_input" ref="three_radio_input"
              v-if="form.three_radio == 2">
              <el-input v-model="form.three_radio_input" placeholder="请输入内容" />
            </el-form-item>
          </div>
          <!-- 4 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="4、选择CAR-T细胞治疗时所考虑的因素包括： " prop="four_checkbox" ref="four_checkbox">
              <el-checkbox-group v-model="form.four_checkbox">
                <el-checkbox label="1" name="type">患者年龄</el-checkbox>
                <el-checkbox label="2" name="type">患者性别</el-checkbox>
                <el-checkbox label="3" name="type">疾病分期</el-checkbox>
                <el-checkbox label="4" name="type">病理诊断</el-checkbox>
                <el-checkbox label="5" name="type">复发类型</el-checkbox>
                <el-checkbox label="6" name="type">难治类型</el-checkbox>
                <el-checkbox label="7" name="type">肿瘤负荷</el-checkbox>
                <el-checkbox label="8" name="type">免疫组化类型</el-checkbox>
                <el-checkbox label="9" name="type">CD19表达高低</el-checkbox>
                <el-checkbox label="10" name="type">IPI评分</el-checkbox>
                <el-checkbox label="11" name="type">体能状态 (ECOG)</el-checkbox>
                <el-checkbox label="12" name="type">既往治疗线数</el-checkbox>
                <el-checkbox label="13" name="type">合并脏器功能不足</el-checkbox>
                <div style="display: flex;align-items:center;">
                  <el-checkbox label="14" name="type">有无结外病变</el-checkbox>
                  <el-form-item style="margin: 0;margin-left: 20px;" prop="four_radio1" ref="four_radio1"
                    v-if="form.four_checkbox.includes('14') == true">
                    <el-radio-group v-model="form.four_radio1">
                      <el-radio :label="1">有</el-radio>
                      <el-radio :label="2">无</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <div style="display: flex;align-items:center;margin: 10px 0;">
                  <el-checkbox label="15" name="type">有无中枢侵犯</el-checkbox>
                  <el-form-item style="margin: 0;margin-left: 20px;" prop="four_radio2" ref="four_radio2"
                    v-if="form.four_checkbox.includes('15') == true">
                    <el-radio-group v-model="form.four_radio2">
                      <el-radio :label="1">有</el-radio>
                      <el-radio :label="2">无</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <div>
                  <el-checkbox label="16" name="type">既往是否接受过自体造血干细胞移植</el-checkbox>
                  <el-form-item style="margin: 0;" prop="four_radio3" ref="four_radio3"
                    v-if="form.four_checkbox.includes('16') == true">
                    <el-radio-group v-model="form.four_radio3">
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </el-checkbox-group>
            </el-form-item>
          </div>
          <!-- 5 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="5、本次单采所采取的细胞采集方式为：" prop="five_radio" ref="five_radio">
              <el-radio-group v-model="form.five_radio">
                <el-radio :label="1">外周导管采集</el-radio>
                <el-radio :label="2">中心静脉导管采集</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <!-- 6 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="6、此次单采时间：" prop="six_input1" ref="six_input1">
              <div class="form-on-input" style="color: #606266;">
                单采开始时间点：
                <el-form-item style="margin: 0;" prop="six_input1" ref="six_input1">
                  <el-input style="width: 140px;" v-model="form.six_input1" placeholder="" />
                </el-form-item>
                <el-form-item style="margin-top: 3px;" prop="six_radio1" ref="six_radio1">
                  <el-radio-group v-model="form.six_radio1">
                    <el-radio :label="1">上午</el-radio>
                    <el-radio :label="2">下午</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <div class="form-on-input" style="color: #606266;">
                单采结束时间点：
                <el-form-item style="margin: 0;" prop="six_input2" ref="six_input2">
                  <el-input style="width: 140px;" v-model="form.six_input2" placeholder="" />
                </el-form-item>
                <el-form-item style="margin-top: 3px;" prop="six_radio2" ref="six_radio2">
                  <el-radio-group v-model="form.six_radio2">
                    <el-radio :label="1">上午</el-radio>
                    <el-radio :label="2">下午</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <div class="form-on-input" style="color: #606266;">
                全程所花费时长：
                <el-form-item style="margin: 0;" prop="six_input3" ref="six_input3">
                  <el-input style="width: 50px;" v-model="form.six_input3" placeholder="" />
                </el-form-item>
                h
                <el-form-item style="margin: 0;" prop="six_input4" ref="six_input4">
                  <el-input style="width: 50px;" v-model="form.six_input4" placeholder="" />
                </el-form-item>
                mins
              </div>
            </el-form-item>
          </div>
          <!-- 7 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="7、是否对本病例实施桥接治疗：" prop="seven_radio" ref="seven_radio">
              <el-radio-group v-model="form.seven_radio" @change="sevenChange">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="form-radio-b" style="margin-top: 0;" prop="seven_radio_input" ref="seven_radio_input"
              label="原因：">
              <el-input v-model="form.seven_radio_input" placeholder="请输入内容" />
            </el-form-item>
          </div>
          <!-- 8 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="" prop="eight_input" ref="eight_input">
              <div class="form-on-input" style="color: #606266;">
                <div>
                  <div class="form-on-input-xing">*</div>8、本病例从单采结束到CAR-T细胞回输的时间间隔为：
                  <el-input style="width: 110px;" v-model="form.eight_input" placeholder="" />
                  天。
                </div>
              </div>
            </el-form-item>
          </div>
          <!-- 9 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="9、此次CAR-T细胞回输时采用的中心静脉通路方式：" prop="nine_radio" ref="nine_radio">
              <el-radio-group v-model="form.nine_radio">
                <el-radio :label="1">双腔导管</el-radio>
                <el-radio :label="2">三腔导管</el-radio>
                <el-radio :label="3">其他</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="form-radio-b" style="margin-top: 0;" prop="nine_radio_input" ref="nine_radio_input"
              v-if="form.nine_radio == 3">
              <el-input v-model="form.nine_radio_input" placeholder="请输入内容" />
            </el-form-item>
          </div>
          <!-- 10 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="10、此次CAR-T细胞回输过程中，是否出现以下不良反应：" prop="ten_checkbox"
              ref="ten_checkbox">
              <el-checkbox-group v-model="form.ten_checkbox">
                <el-checkbox label="1" name="type">细胞因子释放综合征</el-checkbox>
                <el-checkbox label="2" name="type">免疫效应细胞相关的神经毒性（ICANS）</el-checkbox>
                <el-checkbox label="3" name="type">心律失常</el-checkbox>
                <el-checkbox label="4" name="type">肿瘤溶解综合征</el-checkbox>
                <el-checkbox label="5" name="type">癫痫</el-checkbox>
                <el-checkbox style="margin-bottom: 0;" label="6" name="type">其他</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item style="margin-top: 0;" class="form-radio-b" prop="ten_checkbox_input" ref="ten_checkbox_input"
              v-if="form.ten_checkbox.includes('6') == true">
              <el-input v-model="form.ten_checkbox_input" placeholder="请输入内容" />
            </el-form-item>
            <div class="form-on-input" style="margin-top: 15px;margin-left: 10px;">
              <div style="padding-left: 10px;">
                如出现，请注明处理策略：
              </div>
              <el-form-item style="margin: 0;" prop="ten_input" ref="ten_input">
                <el-input style="width: 250px;" v-model="form.ten_input" placeholder="请输入内容" />
              </el-form-item>
            </div>
          </div>
          <!-- 11 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="11、CAR-T制备期间，哪些患者可接受桥接治疗以稳定疾病状态、预防快速进展： " prop="eleven_checkbox"
              ref="eleven_checkbox">
              <el-checkbox-group v-model="form.eleven_checkbox">
                <el-checkbox label="1" name="type">大包块</el-checkbox>
                <el-checkbox label="2" name="type">疾病进展迅速</el-checkbox>
                <el-checkbox label="3" name="type">CAR-T制备时间过长导致疾病进展</el-checkbox>
                <el-checkbox label="4" name="type">疾病所在部位</el-checkbox>
                <el-checkbox label="5" name="type">LDH升高</el-checkbox>
                <el-checkbox label="6" name="type">高IPI评分</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
          <!-- 12 -->
          <div class="form-in" v-if="sevenShow">
            <el-form-item class="form-radio-b" label="12、本病例接受的桥接治疗方案为（请注明具体药物方案周期及剂量）：" prop="twelve_input"
              ref="twelve_input">
              <el-input v-model="form.twelve_input" placeholder="请输入内容" />
            </el-form-item>
          </div>
          <!-- 13 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="13、本中心常用的桥接治疗方案为：" prop="thirteen_checkbox" ref="thirteen_checkbox">
              <el-checkbox-group v-model="form.thirteen_checkbox">
                <el-checkbox label="1" name="type">激素</el-checkbox>
                <el-checkbox label="2" name="type">（免疫）化疗</el-checkbox>
                <el-checkbox label="3" name="type">放疗</el-checkbox>
                <el-checkbox label="4" name="type">含Pola方案</el-checkbox>
                <el-checkbox label="5" name="type">含BTK抑制剂方案</el-checkbox>
                <el-checkbox style="margin-bottom: 0;" label="6" name="type">其他</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item style="margin-top: 0;" class="form-radio-b" prop="thirteen_checkbox_input"
              ref="thirteen_checkbox_input" v-if="form.thirteen_checkbox.includes('6') == true">
              <el-input v-model="form.thirteen_checkbox_input" placeholder="请输入内容" />
            </el-form-item>
          </div>
          <!-- 14 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="14、清淋治疗是否采用标准FC方案（环磷酰胺500 mg/m² +氟达拉滨30 mg/m²）："
              prop="fourteen_radio" ref="fourteen_radio">
              <el-radio-group v-model="form.fourteen_radio" @change="fourteenChange">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <!-- 15 -->
          <div class="form-in" v-if="fourteenShow">
            <el-form-item class="form-radio-b" label="15、如果清淋治疗未采用标准FC方案，请注明具体方案情况：" prop="fifteen_checkbox"
              ref="fifteen_checkbox">
              <el-checkbox-group v-model="form.fifteen_checkbox">
                <div>
                  <el-checkbox label="1" name="type">苯达莫司汀</el-checkbox>
                  <el-form-item style="margin-top: 0;" class="form-radio-b"
                    v-if="form.fifteen_checkbox.includes('1') == true">
                    <div class="form-on-input" style="color: #606266;display: flex;">
                      用药剂量：
                      <el-form-item style="margin: 0;" prop="fifteen_checkbox_input1" ref="fifteen_checkbox_input1">
                        <el-input style="width: 200px;" v-model="form.fifteen_checkbox_input1" placeholder="请输入内容" />
                      </el-form-item>
                    </div>
                  </el-form-item>
                </div>
                <div style="margin: 10px 0;">
                  <el-checkbox label="2" name="type">FC+X方案</el-checkbox>
                  <el-form-item style="margin-top: 0;" class="form-radio-b"
                    v-if="form.fifteen_checkbox.includes('2') == true">
                    <div class="form-on-input" style="color: #606266;">
                      用药剂量：F
                      <el-form-item style="margin: 0;" prop="fifteen_checkbox_input2" ref="fifteen_checkbox_input2">
                        <el-input style="width: 190px;" v-model="form.fifteen_checkbox_input2" placeholder="请输入内容" />
                      </el-form-item>
                      <div style="display: flex;align-items: center;">
                        用药剂量：C
                        <el-form-item style="margin: 0;" prop="fifteen_checkbox_input3" ref="fifteen_checkbox_input3">
                          <el-input style="width: 190px;" v-model="form.fifteen_checkbox_input3" placeholder="请输入内容" />
                        </el-form-item>
                      </div>
                      <div style="display: flex;align-items: center;">
                        用药剂量：X
                        <el-form-item style="margin: 0;" prop="fifteen_checkbox_input4" ref="fifteen_checkbox_input4">
                          <el-input style="width: 190px;" v-model="form.fifteen_checkbox_input4" placeholder="请输入内容" />
                        </el-form-item>
                      </div>
                    </div>
                  </el-form-item>
                </div>
                <div>
                  <el-checkbox label="3" name="type">FC减量方案</el-checkbox>
                  <el-form-item style="margin-top: 0;" class="form-radio-b"
                    v-if="form.fifteen_checkbox.includes('3') == true">
                    <div class="form-on-input" style="color: #606266;">
                      用药剂量：F
                      <el-form-item style="margin: 0;" prop="fifteen_checkbox_input5" ref="fifteen_checkbox_input5">
                        <el-input style="width: 190px;" v-model="form.fifteen_checkbox_input5" placeholder="请输入内容" />
                      </el-form-item>
                      <div style="display: flex;align-items: center;">
                        用药剂量：C
                        <el-form-item style="margin: 0;" prop="fifteen_checkbox_input6" ref="fifteen_checkbox_input6">
                          <el-input style="width: 190px;" v-model="form.fifteen_checkbox_input6" placeholder="请输入内容" />
                        </el-form-item>
                      </div>
                    </div>
                  </el-form-item>
                </div>
              </el-checkbox-group>
            </el-form-item>

          </div>
          <!-- 16 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="16、CAR-T细胞回输后0-28天短期监测内，是否出现细胞因子释放综合征（CRS）：" prop="sixteen_radio"
              ref="sixteen_radio">
              <el-radio-group v-model="form.sixteen_radio">
                <el-radio :label="1">否</el-radio>
                <el-radio :label="2">是</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item style="margin-top: 0;" v-if="form.sixteen_radio == 2">
              <div class="form-on-input" style="color: #606266;">
                <div style="display: flex;">
                  回输后第
                  <el-form-item style="margin: 0;" prop="sixteen_input1" ref="sixteen_input1">
                    <el-input style="width: 110px;" v-model="form.sixteen_input1" placeholder="请输入内容" />
                  </el-form-item>
                  天出现1级CRS，
                </div>
                <div style="display: flex;">
                  处理策略
                  <el-form-item style="margin: 0;" prop="sixteen_input2" ref="sixteen_input2">
                    <el-input style="width: 230px;" v-model="form.sixteen_input2" placeholder="请输入内容" />
                  </el-form-item>
                </div>
                持续时间为
                <el-form-item style="margin: 0;" prop="sixteen_input3" ref="sixteen_input3">
                  <el-input style="width: 110px;" v-model="form.sixteen_input3" placeholder="请输入内容" />
                </el-form-item>
                天

                回输后第
                <el-form-item style="margin: 0;" prop="sixteen_input4" ref="sixteen_input4">
                  <el-input style="width: 110px;" v-model="form.sixteen_input4" placeholder="请输入内容" />
                </el-form-item>
                天出现2级CRS，
                <div style="display: flex;">
                  处理策略
                  <el-form-item style="margin: 0;" prop="sixteen_input5" ref="sixteen_input5">
                    <el-input style="width: 230px;" v-model="form.sixteen_input5" placeholder="请输入内容" />
                  </el-form-item>
                </div>
                持续时间为
                <el-form-item style="margin: 0;" prop="sixteen_input6" ref="sixteen_input6">
                  <el-input style="width: 110px;" v-model="form.sixteen_input6" placeholder="请输入内容" />
                </el-form-item>
                天

                回输后第
                <el-form-item style="margin: 0;" prop="sixteen_input7" ref="sixteen_input7">
                  <el-input style="width: 110px;" v-model="form.sixteen_input7" placeholder="请输入内容" />
                </el-form-item>
                天出现≥3级CRS，
                <div style="display: flex;">
                  处理策略
                  <el-form-item style="margin: 0;" prop="sixteen_input8" ref="sixteen_input8">
                    <el-input style="width: 230px;" v-model="form.sixteen_input8" placeholder="请输入内容" />
                  </el-form-item>
                </div>
                持续时间为
                <el-form-item style="margin: 0;" prop="sixteen_input9" ref="sixteen_input9">
                  <el-input style="width: 110px;" v-model="form.sixteen_input9" placeholder="请输入内容" />
                </el-form-item>
                天
              </div>
            </el-form-item>
          </div>
          <!-- 17 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="17、CAR-T细胞回输后0-28天短期监测内，是否出现神经系统毒性（NE）：" prop="seventeen_radio"
              ref="seventeen_radio">
              <el-radio-group v-model="form.seventeen_radio">
                <el-radio :label="1">否</el-radio>
                <el-radio :label="2">是</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item style="margin-top: 0;" v-if="form.seventeen_radio == 2">
              <div class="form-on-input" style="color: #606266;">
                回输后第
                <el-form-item style="margin: 0;" prop="sixteen_input1" ref="sixteen_input1">
                  <el-input style="width: 110px;" v-model="form.seventeen_radio_input1" placeholder="请输入内容" />
                </el-form-item>
                天出现1级NE，
                <div style="display: flex;">
                  处理策略
                  <el-form-item style="margin: 0;" prop="seventeen_radio_input2" ref="seventeen_radio_input2">
                    <el-input style="width: 230px;" v-model="form.seventeen_radio_input2" placeholder="请输入内容" />
                  </el-form-item>
                </div>
                持续时间为
                <el-form-item style="margin: 0;" prop="seventeen_radio_input3" ref="seventeen_radio_input3">
                  <el-input style="width: 110px;" v-model="form.seventeen_radio_input3" placeholder="请输入内容" />
                </el-form-item>
                天

                回输后第
                <el-form-item style="margin: 0;" prop="seventeen_radio_input4" ref="seventeen_radio_input4">
                  <el-input style="width: 110px;" v-model="form.seventeen_radio_input4" placeholder="请输入内容" />
                </el-form-item>
                天出现2级NE，
                <div style="display: flex;">
                  处理策略
                  <el-form-item style="margin: 0;" prop="seventeen_radio_input5" ref="seventeen_radio_input5">
                    <el-input style="width: 230px;" v-model="form.seventeen_radio_input5" placeholder="请输入内容" />
                  </el-form-item>
                </div>
                持续时间为
                <el-form-item style="margin: 0;" prop="seventeen_radio_input6" ref="seventeen_radio_input6">
                  <el-input style="width: 110px;" v-model="form.seventeen_radio_input6" placeholder="请输入内容" />
                </el-form-item>
                天

                回输后第
                <el-form-item style="margin: 0;" prop="seventeen_radio_input7" ref="seventeen_radio_input7">
                  <el-input style="width: 110px;" v-model="form.seventeen_radio_input7" placeholder="请输入内容" />
                </el-form-item>
                天出现≥3级NE，
                <div style="display: flex;">
                  处理策略
                  <el-form-item style="margin: 0;" prop="seventeen_radio_input8" ref="seventeen_radio_input8">
                    <el-input style="width: 230px;" v-model="form.seventeen_radio_input8" placeholder="请输入内容" />
                  </el-form-item>
                </div>
                持续时间为
                <el-form-item style="margin: 0;" prop="seventeen_radio_input9" ref="seventeen_radio_input9">
                  <el-input style="width: 110px;" v-model="form.seventeen_radio_input9" placeholder="请输入内容" />
                </el-form-item>
                天
              </div>
            </el-form-item>
          </div>
          <!-- 18 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="18、0-28天短期监测过程中所出现的其他的严重不良反应有：" prop="eighteen_checkbox"
              ref="eighteen_checkbox">
              <el-checkbox-group v-model="form.eighteen_checkbox">
                <el-checkbox label="1" name="type">巨噬细胞活化综合征（MAS）</el-checkbox>
                <el-checkbox label="2" name="type">血细胞减少症</el-checkbox>
                <el-checkbox label="3" name="type">严重感染</el-checkbox>
                <el-checkbox label="4" name="type">B细胞再生障碍/低丙种球蛋白血症</el-checkbox>
                <el-checkbox style="margin-bottom: 0;" label="5" name="type">其他</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item style="margin-top: 0;" class="form-radio-b" prop="eighteen_checkbox_input"
              ref="eighteen_checkbox_input" v-if="form.eighteen_checkbox.includes('5') == true">
              <el-input v-model="form.eighteen_checkbox_input" placeholder="请输入内容" />
            </el-form-item>
          </div>
          <!-- 19 -->
          <div class="form-in">
            <el-form-item class="form-radio-b">
              <div class="form-on-input" style="color: #606266;">
                <div class="form-on-input-xing">*</div>19、平均1个月内，您接诊的大B细胞淋巴瘤
                <div style="display: flex;">
                  （LBCL）患者约有
                  <el-form-item style="margin: 0;" prop="nineteen_input1" ref="nineteen_input1">
                    <el-input style="width: 80px;" v-model="form.nineteen_input1" placeholder="" />
                  </el-form-item>
                  例。
                </div>
                <div style="display: flex;">
                  其中初治患者比例约为
                  <el-form-item style="margin: 0;" prop="nineteen_input2" ref="nineteen_input2">
                    <el-input style="width: 100px;" v-model="form.nineteen_input2" placeholder="" />
                  </el-form-item>
                  %，
                </div>
                <div style="display: flex;">
                  一线免疫化疗后难治的患者比例约为
                  <el-form-item style="margin: 0;" prop="nineteen_input3" ref="nineteen_input3">
                    <el-input style="width: 37px;" v-model="form.nineteen_input3" placeholder="" />
                  </el-form-item>
                  %，
                </div>
                <div style="display: flex;">
                  一线免疫化疗后复发的患者比例约为
                  <el-form-item style="margin: 0;" prop="nineteen_input4" ref="nineteen_input4">
                    <el-input style="width: 37px;" v-model="form.nineteen_input4" placeholder="" />
                  </el-form-item>
                  %
                </div>
                <div style="display: flex;">
                  （其中≤12个月复发的患者比例约为
                  <el-form-item style="margin: 0;" prop="nineteen_input5" ref="nineteen_input5">
                    <el-input style="width: 40px;" v-model="form.nineteen_input5" placeholder="" />
                  </el-form-item>
                  %，
                </div>
                <div style="display: flex;">
                  >12个月复发的患者比例约为
                  <el-form-item style="margin: 0;" prop="nineteen_input6" ref="nineteen_input6">
                    <el-input style="width: 70px;" v-model="form.nineteen_input6" placeholder="" />
                  </el-form-item>
                  %）。
                </div>
              </div>
            </el-form-item>
          </div>
          <!-- 20 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="20、在为RR LBCL患者选择治疗方案时，您通常会重点考虑哪些与治疗相关的因素？" prop="twenty_checkbox"
              ref="twenty_checkbox">
              <el-checkbox-group v-model="form.twenty_checkbox">
                <el-checkbox label="1" name="type">年龄</el-checkbox>
                <el-checkbox label="2" name="type">疾病分期</el-checkbox>
                <el-checkbox label="3" name="type">GCB/non-GCB 双表达</el-checkbox>
                <el-checkbox label="4" name="type">双/三打击</el-checkbox>
                <el-checkbox label="5" name="type">IPI评分</el-checkbox>
                <el-checkbox label="6" name="type">ECOG评分</el-checkbox>
                <el-checkbox label="7" name="type">基因分型</el-checkbox>
                <el-checkbox label="8" name="type">中枢侵犯</el-checkbox>
                <el-checkbox label="9" name="type">结外病变部位</el-checkbox>
                <el-checkbox label="10" name="type">结外侵犯个数</el-checkbox>
                <el-checkbox label="11" name="type">巨块病变</el-checkbox>
                <el-checkbox label="12" name="type">LDH</el-checkbox>
                <el-checkbox label="13" name="type">原发难治</el-checkbox>
                <el-checkbox label="14" name="type">早期复发/进展</el-checkbox>
                <el-checkbox label="15" name="type">患者脏器合并症</el-checkbox>
                <el-checkbox label="16" name="type" style="margin-right: 140px;">是否符合移植条件</el-checkbox>
                <el-checkbox style="margin-bottom: 0;" label="17" name="type">其他</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item style="margin-top: 0;" class="form-radio-b" prop="twenty_checkbox_input"
              ref="twenty_checkbox_input" v-if="form.twenty_checkbox.includes('17') == true">
              <el-input v-model="form.twenty_checkbox_input" placeholder="请输入内容" />
            </el-form-item>
          </div>
          <!-- 21 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="21、针对RR LBCL患者的二线治疗，您常用的治疗方案有哪些？" prop="twentyone_checkbox"
              ref="twentyone_checkbox">
              <el-checkbox-group v-model="form.twentyone_checkbox">
                <el-checkbox label="1" name="type">R-ICE</el-checkbox>
                <el-checkbox label="2" name="type">R-GemOx</el-checkbox>
                <el-checkbox label="3" name="type">BR</el-checkbox>
                <el-checkbox label="4" name="type">其他含铂类化疗方案</el-checkbox>
                <el-checkbox label="5" name="type">HDT+ASCT</el-checkbox>
                <el-checkbox label="6" name="type">R2（利妥昔单抗+来那度胺）</el-checkbox>
                <el-checkbox label="7" name="type">CAR-T细胞治疗</el-checkbox>
                <el-checkbox label="8" name="type">BTKi+化疗</el-checkbox>
                <el-checkbox style="margin-bottom: 0;" label="9" name="type">其他</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item style="margin-top: 0;" class="form-radio-b" prop="twentyone_checkbox_input"
              ref="twentyone_checkbox_input" v-if="form.twentyone_checkbox.includes('9') == true">
              <el-input v-model="form.twentyone_checkbox_input" placeholder="请输入内容" />
            </el-form-item>
          </div>
          <!-- 22 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="22、对于哪些RR LBCL患者，您在治疗时会考虑使用CAR-T疗法：" prop="twentytwo_checkbox"
              ref="twentytwo_checkbox">
              <el-checkbox-group v-model="form.twentytwo_checkbox">
                <el-checkbox label="1" name="type">12个月内复发的患者</el-checkbox>
                <el-checkbox label="2" name="type">原发耐药的DLBCL </el-checkbox>
                <el-checkbox label="3" name="type">不适合行移植治疗的患者</el-checkbox>
                <el-checkbox label="4" name="type">移植后复发的患者</el-checkbox>
                <el-checkbox label="5" name="type" class="form-checkbox-br"
                  style="padding-bottom: 15px;">合并高危因素的DLBCL（三打击、双打击、TP53突变等）</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
          <!-- 23 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="23、在RR LBCL患者的常用二线治疗方案中，您认为主要的瓶颈或不足体现在哪些方面："
              prop="twentythree_checkbox" ref="twentythree_checkbox">
              <el-checkbox-group v-model="form.twentythree_checkbox">
                <el-checkbox label="1" name="type">OS延长有限</el-checkbox>
                <el-checkbox label="2" name="type">PFS延长有限</el-checkbox>
                <el-checkbox label="3" name="type">易发生耐药</el-checkbox>
                <el-checkbox label="4" name="type">不良反应较多</el-checkbox>
                <el-checkbox label="5" name="type" style="margin-right: 200px;">治疗周期长</el-checkbox>
                <el-checkbox style="margin-bottom: 0;" label="6" name="type">其他</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item style="margin-top: 0;" class="form-radio-b" prop="twentythree_checkbox_input"
              ref="twentythree_checkbox_input" v-if="form.twentythree_checkbox.includes('6') == true">
              <el-input v-model="form.twentythree_checkbox_input" placeholder="请输入内容" />
            </el-form-item>
          </div>
          <!-- 24 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="24、可以用于RR LBCL患者二线治疗的新治疗方案中，您认为哪些比较有潜力：" prop="twentyfour_checkbox"
              ref="twentyfour_checkbox">
              <el-checkbox-group v-model="form.twentyfour_checkbox">
                <el-checkbox label="1" name="type">CAR-T细胞治疗</el-checkbox>
                <el-checkbox label="2" name="type">PD-1单抗</el-checkbox>
                <el-checkbox label="3" name="type">ADC药物</el-checkbox>
                <el-checkbox label="4" name="type">双抗</el-checkbox>
                <el-checkbox label="5" name="type">BTK抑制剂</el-checkbox>
                <el-checkbox label="6" name="type">BCL-2抑制剂</el-checkbox>
                <el-checkbox label="7" name="type">XPO-1抑制剂</el-checkbox>
                <el-checkbox label="8" name="type">EZH2抑制剂</el-checkbox>
                <el-checkbox style="margin-bottom: 0;" label="9" name="type">其他</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item style="margin-top: 0;" class="form-radio-b" prop="twentyfour_checkbox_input"
              ref="twentyfour_checkbox_input" v-if="form.twentyfour_checkbox.includes('9') == true">
              <el-input v-model="form.twentyfour_checkbox_input" placeholder="请输入内容" />
            </el-form-item>
          </div>
          <!-- 25 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="25、CAR-T用于RR LBCL患者的治疗时，除了经济因素外，您还会有哪些方面的考量？"
              prop="twentyfive_checkbox" ref="twentyfive_checkbox">
              <el-checkbox-group v-model="form.twentyfive_checkbox">
                <el-checkbox label="1" name="type">治疗效果</el-checkbox>
                <el-checkbox label="2" name="type">相关不良反应</el-checkbox>
                <el-checkbox label="3" name="type">患者的依从性</el-checkbox>
                <el-checkbox label="4" name="type">团队治疗经验不足 </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
          <!-- 26 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="26、根据现有的临床证据，您认为CAR-T细胞治疗在哪些侵袭性淋巴瘤中可能具有较好的疗效："
              prop="twentysix_checkbox" ref="twentysix_checkbox">
              <el-checkbox-group v-model="form.twentysix_checkbox">
                <el-checkbox label="1" name="type">弥漫大B细胞淋巴瘤非特指型 (DLBCL, NOS)</el-checkbox>
                <el-checkbox label="2" name="type">原发纵隔B细胞淋巴瘤 (PMBCL)</el-checkbox>
                <el-checkbox label="3" name="type">组织学转化的滤泡淋巴瘤 (TFL) </el-checkbox>
                <el-checkbox label="4" name="type" style="margin-right: 80px;">高级别B细胞淋巴瘤 (HGBL)</el-checkbox>
                <el-checkbox style="margin-bottom: 0;" label="5" name="type">其他</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item style="margin-top: 0;" class="form-radio-b" prop="twentysix_checkbox_input"
              ref="twentysix_checkbox_input" v-if="form.twentysix_checkbox.includes('5') == true">
              <el-input v-model="form.twentysix_checkbox_input" placeholder="请输入内容" />
            </el-form-item>
          </div>
          <!-- 27 -->
          <div class="form-in">
            <el-form-item class="form-radio-b" label="27、关于CAR-T细胞治疗的安全性，您持什么观点：" prop="twentyseven_checkbox"
              ref="twentyseven_checkbox">
              <el-checkbox-group v-model="form.twentyseven_checkbox">
                <el-checkbox label="1" name="type">安全性可控</el-checkbox>
                <el-checkbox label="2" name="type">安全问题可预防</el-checkbox>
                <el-checkbox label="3" name="type">安全问题可能导致治疗失败</el-checkbox>
                <el-checkbox label="4" name="type">安全问题可提前进行个体化评估</el-checkbox>
                <el-checkbox label="5" name="type">抗白细胞介素-6受体单抗可用于CRS管理</el-checkbox>
                <el-checkbox label="6" name="type" style="margin-right: 70px;">糖皮质激素可用于神经毒性管理</el-checkbox>
                <el-checkbox style="margin-bottom: 0;" label="7" name="type">其他</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item style="margin-top: 0;" class="form-radio-b" prop="twentyseven_checkbox_input"
              ref="twentyseven_checkbox_input" v-if="form.twentyseven_checkbox.includes('7') == true">
              <el-input v-model="form.twentyseven_checkbox_input" placeholder="请输入内容" />
            </el-form-item>
          </div>
          <div class="form-yinsi">
            <div class="form-yinsi-title">
              <i class="el-icon-lock" style="color: #108CEE; margin-right: 5px;margin-bottom: 1px;"></i>
              <div>隐私保护</div>
            </div>
            <div class="form-yinsi-text" style="margin-bottom: 10px;">您提供的个人信息和回答将仅用于统计分析和研究。</div>
            <div class="form-yinsi-text">
              非常感谢您抽出宝贵时间参与本次调查，您的意见和
              建议对我们非常重要！
            </div>
          </div>
          <div class="form-btn">
            <el-button style="width: 100%;height: 100%;   border-radius: 18px;" type="primary"
              @click="submitForm('form')">
              提交
            </el-button>
          </div>
          <!--  -->
        </el-form>
      </div>
      <!-- 表单 -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        one_checkbox: [],//1
        one_checkbox_input: '',//1 
        two_radio: '',//2  
        three_radio: [],//3  
        three_radio_input: '',//3    
        four_checkbox: [],//4 
        four_radio1: '',//4 
        four_radio2: '',//4
        four_radio3: '',//4
        five_radio: '',//5   
        six_input1: '',//6  
        six_input2: '',//6  
        six_input3: '',//6  
        six_input4: '',//6 
        six_radio1: '',//6 
        six_radio2: '',//6 
        seven_radio: '',//7 
        seven_radio_input: '',//7     
        eight_input: '',//8 
        nine_radio: '',//9  
        nine_radio_input: '',//9  
        ten_checkbox: [],//10     
        ten_checkbox_input: '',//10  
        ten_input: "",//10 
        eleven_checkbox: [],//11
        twelve_input: '',//12
        thirteen_checkbox: [],//13
        thirteen_checkbox_input: '',//13
        fourteen_radio: '',//14 
        fifteen_checkbox: [],//15
        fifteen_checkbox_input1: '',//15
        fifteen_checkbox_input2: '',//15
        fifteen_checkbox_input3: '',//15
        fifteen_checkbox_input4: '',//15 
        fifteen_checkbox_input5: '',//15   
        fifteen_checkbox_input6: '',//15 
        sixteen_radio: '',//16 
        sixteen_input1: '',//16
        sixteen_input2: '',//16
        sixteen_input3: '',//16
        sixteen_input4: '',//16
        sixteen_input5: '',//16 
        sixteen_input6: '',//16
        sixteen_input7: '',//16 
        sixteen_input8: '',//16
        sixteen_input9: '',//16
        seventeen_radio: '',//17 
        seventeen_radio_input1: '',//17
        seventeen_radio_input2: '',//17
        seventeen_radio_input3: '',//17 
        seventeen_radio_input4: '',//17  
        seventeen_radio_input5: '',//17 
        seventeen_radio_input6: '',//17
        seventeen_radio_input7: '',//17 
        seventeen_radio_input8: '',//17
        seventeen_radio_input9: '',//17
        eighteen_checkbox: [],//18  
        eighteen_checkbox_input: '',//18  
        nineteen_input1: '',//19
        nineteen_input2: '',
        nineteen_input3: '',
        nineteen_input4: '',
        nineteen_input5: '',
        nineteen_input6: '',//19
        twenty_checkbox: [],//20
        twenty_checkbox_input: '',//20  
        twentyone_checkbox: [],//21 
        twentyone_checkbox_input: '',//21   
        twentytwo_checkbox: [],//22
        twentythree_checkbox: [],//23 
        twentythree_checkbox_input: '',//23 
        twentyfour_checkbox: [],//24
        twentyfour_checkbox_input: '',//24 
        twentyfive_checkbox: [],//25
        twentysix_checkbox: [],//26
        twentysix_checkbox_input: '',//26  
        twentyseven_checkbox: [],//27 
        twentyseven_checkbox_input: '',//27      
      },
      rules: {
        six_input1: [{ required: true, message: "请输入内容", trigger: "blur" }],
        six_input2: [{ required: true, message: "请输入内容", trigger: "blur" }],
        six_input3: [{ required: true, message: "请输入内容", trigger: "blur" }],
        six_input4: [{ required: true, message: "请输入内容", trigger: "blur" }],
        six_radio1: [{ required: true, message: "请选择内容", trigger: "change" }],
        six_radio2: [{ required: true, message: "请选择内容", trigger: "change" }],
        one_checkbox: [{ required: true, message: "请选择内容", trigger: "change" }],
        one_checkbox_input: [{ required: true, message: "请输入内容", trigger: "blur" }],
        two_radio: [{ required: true, message: "请选择内容", trigger: "change" }],
        three_radio: [{ required: true, message: "请选择内容", trigger: "change" }],
        three_radio_input: [{ required: true, message: "请输入内容", trigger: "blur" }],
        four_checkbox: [{ required: true, message: "请选择内容", trigger: "change" }],
        four_radio1: [{ required: true, message: "请选择内容", trigger: "change" }],
        four_radio2: [{ required: true, message: "请选择内容", trigger: "change" }],
        four_radio3: [{ required: true, message: "请选择内容", trigger: "change" }],
        five_radio: [{ required: true, message: "请选择内容", trigger: "change" }],
        seven_radio: [{ required: true, message: "请选择内容", trigger: "change" }],
        seven_radio_input: [{ required: true, message: "请输入内容", trigger: "blur" }],
        eight_input: [{ required: true, message: "请输入内容", trigger: "blur" }],
        nine_radio: [{ required: true, message: "请选择内容", trigger: "change" }],
        nine_radio_input: [{ required: true, message: "请输入内容", trigger: "blur" }],
        ten_checkbox: [{ required: true, message: "请选择内容", trigger: "change" }],
        ten_checkbox_input: [{ required: true, message: "请输入内容", trigger: "blur" }],
        ten_input: [{ required: true, message: "请输入内容", trigger: "blur" }],
        eleven_checkbox: [{ required: true, message: "请选择内容", trigger: "change" }],
        twelve_input: [{ required: true, message: "请输入内容", trigger: "blur" }],
        thirteen_checkbox: [{ required: true, message: "请选择内容", trigger: "change" }],
        thirteen_checkbox_input: [{ required: true, message: "请输入内容", trigger: "blur" }],
        fifteen_checkbox: [{ required: true, message: "请选择内容", trigger: "change" }],
        fifteen_checkbox_input1: [{ required: true, message: "请输入内容", trigger: "blur" }],
        fifteen_checkbox_input2: [{ required: true, message: "请输入内容", trigger: "blur" }],
        fifteen_checkbox_input3: [{ required: true, message: "请输入内容", trigger: "blur" }],
        fifteen_checkbox_input4: [{ required: true, message: "请输入内容", trigger: "blur" }],
        fifteen_checkbox_input5: [{ required: true, message: "请输入内容", trigger: "blur" }],
        fifteen_checkbox_input6: [{ required: true, message: "请输入内容", trigger: "blur" }],
        fourteen_radio: [{ required: true, message: "请选择内容", trigger: "change" }],
        sixteen_radio: [{ required: true, message: "请选择内容", trigger: "change" }],
        sixteen_input1: [{ required: true, message: "请输入内容", trigger: "blur" }],
        sixteen_input2: [{ required: true, message: "请输入内容", trigger: "blur" }],
        sixteen_input3: [{ required: true, message: "请输入内容", trigger: "blur" }],
        sixteen_input4: [{ required: true, message: "请输入内容", trigger: "blur" }],
        sixteen_input5: [{ required: true, message: "请输入内容", trigger: "blur" }],
        sixteen_input6: [{ required: true, message: "请输入内容", trigger: "blur" }],
        sixteen_input7: [{ required: true, message: "请输入内容", trigger: "blur" }],
        sixteen_input8: [{ required: true, message: "请输入内容", trigger: "blur" }],
        sixteen_input9: [{ required: true, message: "请输入内容", trigger: "blur" }],

        seventeen_radio: [{ required: true, message: "请选择内容", trigger: "change" }],
        seventeen_radio_input1: [{ required: true, message: "请输入内容", trigger: "blur" }],
        seventeen_radio_input2: [{ required: true, message: "请输入内容", trigger: "blur" }],
        seventeen_radio_input3: [{ required: true, message: "请输入内容", trigger: "blur" }],
        seventeen_radio_input4: [{ required: true, message: "请输入内容", trigger: "blur" }],
        seventeen_radio_input5: [{ required: true, message: "请输入内容", trigger: "blur" }],
        seventeen_radio_input6: [{ required: true, message: "请输入内容", trigger: "blur" }],
        seventeen_radio_input7: [{ required: true, message: "请输入内容", trigger: "blur" }],
        seventeen_radio_input8: [{ required: true, message: "请输入内容", trigger: "blur" }],
        seventeen_radio_input9: [{ required: true, message: "请输入内容", trigger: "blur" }],

        eighteen_checkbox: [{ required: true, message: "请选择内容", trigger: "change" }],
        eighteen_checkbox_input: [{ required: true, message: "请输入内容", trigger: "blur" }],
        nineteen_input1: [{ required: true, message: "请输入内容", trigger: "blur" }],
        nineteen_input2: [{ required: true, message: "请输入内容", trigger: "blur" }],
        nineteen_input3: [{ required: true, message: "请输入内容", trigger: "blur" }],
        nineteen_input4: [{ required: true, message: "请输入内容", trigger: "blur" }],
        nineteen_input5: [{ required: true, message: "请输入内容", trigger: "blur" }],
        nineteen_input6: [{ required: true, message: "请输入内容", trigger: "blur" }],
        twenty_checkbox: [{ required: true, message: "请选择内容", trigger: "change" }],
        twenty_checkbox_input: [{ required: true, message: "请输入内容", trigger: "blur" }],
        twentyone_checkbox: [{ required: true, message: "请选择内容", trigger: "change" }],
        twentyone_checkbox_input: [{ required: true, message: "请输入内容", trigger: "blur" }],
        twentytwo_checkbox: [{ required: true, message: "请选择内容", trigger: "change" }],
        twentythree_checkbox: [{ required: true, message: "请选择内容", trigger: "change" }],
        twentythree_checkbox_input: [{ required: true, message: "请输入内容", trigger: "blur" }],
        twentyfour_checkbox: [{ required: true, message: "请选择您认为哪些比较有潜力", trigger: "change" }],
        twentyfour_checkbox_input: [{ required: true, message: "请输入内容", trigger: "blur" }],
        twentyfive_checkbox: [{ required: true, message: "请选择哪些方面的考量", trigger: "change" }],
        twentysix_checkbox: [{ required: true, message: "请选择具有较好的疗效", trigger: "change" }],
        twentysix_checkbox_input: [{ required: true, message: "请输入内容", trigger: "blur" }],
        twentyseven_checkbox: [{ required: true, message: "请选择您的观点", trigger: "change" }],
        twentyseven_checkbox_input: [{ required: true, message: "请输入内容", trigger: "blur" }],
        //=================================================================   
      },
      sevenShow: true,//第7选否不展示12  
      fourteenShow: true,//第14选否15不展示
    }
  },
  created() { },
  mounted() { },
  methods: {
    //表单接口  
    async getsubmitApi() {
      const { data: data } = await this.$http.post(
        "medical/survey",
        this.form
      );
      this.$toast(data.message);
      this.$router.push({ path: "CARprocedure" });
    },
    //提交
    submitForm(formName) {
      this.$refs[formName].validate((valid, object) => {
        if (valid) {
          this.getsubmitApi();
        } else {
          console.log("error submit!!");
          this.scrollToView(this, object);
          return false;
        }
      });
    },
    //7
    sevenChange(v,) {
      if (v == 2) {
        this.sevenShow = false
        this.form.twelve_input = ''
      } else {
        this.sevenShow = true
      }
    },
    //14
    fourteenChange(v,) {
      if (v == 1) {
        this.fourteenShow = false
        this.form.fifteen_checkbox = []
        this.form.fifteen_checkbox_input1 = ''
        this.form.fifteen_checkbox_input2 = ''
        this.form.fifteen_checkbox_input3 = ''
        this.form.fifteen_checkbox_input4 = ''
        this.form.fifteen_checkbox_input5 = ''
        this.form.fifteen_checkbox_input6 = ''
      } else {
        this.fourteenShow = true
      }
    },
  },
} 
</script> 
<style scoped> .index {
   position: relative;
   top: 0;
   left: -15px;
   width: calc(100% + 30px);
   overflow: hidden;
   position: relative;
   font-size: 14px;
 }

 .index-bgc {
   background-color: #F6F8FF;
 }

 .index-head {
   position: relative;
   padding-bottom: 10px;
   width: 100%;
   height: 96px;
   background: url(@/assets/image/nwe/questionnaire-bgc.png) no-repeat center 0px;
   background-position: center 0px;
   background-size: cover;
   color: #130F0F;
   font-size: 18px;
   font-weight: 600;
   display: flex;
   align-items: center;
   justify-content: center;

 }

 /* 表单 */
 .index-form {
   position: relative;
   top: -15px;
   left: 0;
   border-radius: 23px;
   background-color: #F6F8FF;
   padding: 20px 15px;

 }

 .form {}

 .form-on-input {
   position: relative;
   display: flex;
   flex-wrap: wrap;
   color: #606266
 }

 .form-on-input-xing {
   position: absolute;
   top: 0;
   left: -10px;
   color: #F56C6C;
   /* margin-right: 4px; */
 }

 .form-on-input>>>.el-form-item__error {
   padding-top: 0;
 }

 .form-on-input>>>.el-form-item__content {
   padding-right: 10px !important;
 }

 .form-on-input>>>.el-input__inner {
   position: relative;
   top: 0px;
   border: 0 !important;
   border-bottom: 1px solid #B8C5D9 !important;
   border-radius: 0 !important;
   background-color: rgba(0, 0, 0, 0) !important;
   /* padding: 0 !important; */
   height: 20px;
   line-height: 20px;
   /* padding-left: 5px; */
   padding: 0;
 }

 .el-form-item-b {
   margin-bottom: 10px !important;
 }

 .index-form>>>.el-form-item {
   /* margin-bottom: 30px; */
   /* margin-top: 30px; */
 }

 /* .el-form-item-label>>>.el-form-item__label {
   line-height: 1.5 !important;
 } */


 .index-form>>>.el-form--label-top .el-form-item__label {
   padding: 0 !important;
 }

 .index-form>>>.el-form-item__content {
   padding-left: 10px !important;
 }

 .index-form>>>.el-form-item__error {
   left: 10px;
 }

 .el-form-item-radio-b {
   margin-bottom: 15px;
 }


 .form-radio-item-y {
   margin-top: 5px;
 }

 .form-radio-item-t {
   margin-top: 20px;
   margin-bottom: 3px;
 }

 .form-in {
   background-color: #fff;
   /* padding: 10px 13px 15px 13px; */
   padding: 15px 13px 15px 13px;
   border-radius: 6px;
   margin-bottom: 10px;
 }

 .sex {
   display: flex;
 }

 .age {
   display: flex;
 }

 .date {
   display: flex;
 }

 .form-radio-b {
   margin-bottom: 0px;
 }

 .form-radio-t {
   margin-top: 22px;
 }

 .form-btn {
   margin: 0 auto;
   margin-top: 30px;
   width: 100%;
   height: 38px;
 }

 /* 多选换行 */
 .form-checkbox-br>>>.el-checkbox__label {
   vertical-align: text-top;
   white-space: normal;
   word-break: break-all;
   width: 280px;
 }

 .form-yinsi {
   margin-top: 25px;
   margin-bottom: 30px;
 }

 .form-yinsi-title {
   display: flex;
   align-items: center;
   color: #000000;
   font-size: 15px;
   margin-bottom: 17px;
 }

 .form-yinsi-text {
   color: #000000;
   font-size: 14px;
 }
</style>  